import { useEffect, useState } from 'react';

import { Prices, PricingPageContent } from '../../components/pages/pricingLegacy';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';
import { getUpdatedPricingFeatureFlag, waitForAmplitudeExperimentInitialized } from '../../utils/analytics';

const DEFAULT_PRICES: Prices = {
  monthly: '$9.99',
  yearly: '$69.99',
};

const MODEST_PRICES: Prices = {
  monthly: '$12.99',
  yearly: '$89.99',
};

const Pricing: React.FC = () => {
  usePageVistTracker();
  const [prices, setPrices] = useState<Prices>({ monthly: '', yearly: '' });

  useEffect(() => {
    async function getPrices() {
     await waitForAmplitudeExperimentInitialized(5000);
     const updatedPricingFeatureFlag = getUpdatedPricingFeatureFlag();
     if (updatedPricingFeatureFlag === 'modest-increase') {
       setPrices(MODEST_PRICES);
     } else {
       setPrices(DEFAULT_PRICES);
     }
    }
 
    getPrices();
   }, []);

  return (
    <Layout description="Plans and Pricing at BrainFM" pageTitle="Pricing">
      <PricingPageContent isLocalized={false} price={prices} />
    </Layout>
  );
};

export default Pricing;
